import React from 'react';
import { RectangleButtonStyle, ButtonsContainerStyle, RectangleButtonLinkStyle } from './styles';

export const ButtonsContainer = ({ padding, alignCenter, children }) => {
  return (
    <ButtonsContainerStyle padding={padding} alignCenter={alignCenter}>
      {children}
    </ButtonsContainerStyle>
  );
};

export const RectangleButton = ({
  small,
  marginLeft,
  marginRight,
  marginTop,
  floatRight,
  onClick,
  children,
  disabled,
  id,
  title,
}) => {
  return (
    <RectangleButtonStyle
      id={id}
      title={title}
      disabled={disabled}
      small={small}
      marginLeft={marginLeft}
      marginRight={marginRight}
      marginTop={marginTop}
      floatRight={floatRight}
      onClick={onClick}
    >
      {children}
    </RectangleButtonStyle>
  );
};

// Rectangle button but it is an <a> tag. Using destructured props for a tag attributes
export const RectangleButtonLink = ({ small, marginLeft, marginRight, floatRight, children, ...props }) => {
  return (
    <RectangleButtonLinkStyle
      small={small}
      marginLeft={marginLeft}
      marginRight={marginRight}
      floatRight={floatRight}
      {...props}
    >
      {children}
    </RectangleButtonLinkStyle>
  );
};
